<div class="page-layout carded left-sidenav toolbar-fixed-layout">

    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-center items-start">
            <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
        </div>
        <div
                class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start full-grow-no-shrink-no-basis">
            <label class="component-label"> Actions</label>
            <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

                <div class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="addCompany()"
                            particleAnalytics
                            analyticsCategory="contacts"
                            analyticsAction="add-btn">Add Company
                    </button>

                    <div class="toolbar-separator"></div>
                </div>

                <!--<div class="button-container" fxLayout="row" fxLayoutAlign="start center">
                  <button  [disabled]="selectedItems.length == 0" mat-button class="orbitax-flat-button" (click)="addDashboard()"
                           particleAnalytics
                           analyticsCategory= "contacts"
                           analyticsAction= "delete-btn">Add Dashboard</button>
                  <div class="toolbar-separator"></div>
                </div>-->

            </div>
        </div>

    </div>

    <mat-sidenav-container>
        <div class="center">
            <div class="content-card mat-white-bg">

                <div class="content m-30 flex flex-col">
                    <form class="flex flex-col" [formGroup]="searchCompanyForm" (keydown.enter)="searchCompanies(true)">
                        <div class="w-p-100 flex flex-row justify-start items-start auto-flex">
                            <mat-form-field appearance="outline" class="flex-0-0-25">
                                <mat-label>Search Company</mat-label>
                                <input matInput formControlName="search" [(ngModel)]="searchCompanyForm.value.search"
                                       particleAnalytics
                                       analyticsCategory="account-settings"
                                       analyticsAction="password-input">
                            </mat-form-field>
                            <mat-button-toggle-group class="m-t-10 m-l-10">
                                <mat-button-toggle (click)="searchCompanies(true)" id="searchButton">Search
                                </mat-button-toggle>
                                <mat-button-toggle (click)="clearSearchCompanies()" id="clearSearchButton">Clear Search
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </form>

                    <div class="pos-relative">
                        <div class="keno-grid-container">
                            <particle-smart-grid [sourceType]="sourceType"
                                                 (selectionChanged)="onSelectionChanged($event)"
                                                 [selectableSettings]="selectableSettings"
                                                 (valueChanged)="onValueChanged($event)">
                            </particle-smart-grid>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </mat-sidenav-container>

</div>
